<template>
  <div class="account-pages mt-3">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="text-center mb-5 text-muted">
            <img src="@/assets/images/unicampo.jpg" alt="Imagem logo unicampo" width="55%" loading="lazy" />
            <p class="fs-5">Lei Geral de Proteção de Dados</p>
          </div>
        </div>
      </div>
      <!-- end row -->
      <div class="row justify-content-center">
        <div class="w-50">
          <div class="card shadow-lg mb-5 bg-body rounded">
            <div class="card-body">
              <div class="d-flex">
                <div class="text-center">
                  <div class="avatar-md mx-auto">
                    <div class="avatar-title rounded-circle bg-avatar">
                      <i class="color-avatar bx bx-mail-send h1 mb-0"></i>
                    </div>
                  </div>

                  <div>
                    <h4 class="text-success mb-0 d-flex justify-content-center align-items-center mt-3">Sucesso!</h4>
                  </div>

                    <div class="d-flex flex-column justify-content-center mt-3">
                      <p class="fs-6 text-muted mb-0">
                        A equipe da UNICAMPO recebeu a sua solicitação e realizará uma análise.
                      </p>
                      <p class="fs-6 text-muted">
                        Acompanhe seu e-mail <span class="fw-bold">{{ email }}</span>. Será por ele que todas as
                        notificações serão enviadas. Obrigado!
                        Obrigado!
                      </p>
                    </div>

                  <div>
                      <button @click="redirectToPortal()" class="btn-redirect">
                        Ir para a página inicial
                      </button>
                    </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-5 text-center text-muted">
            <p class="fs-5">
              © {{ new Date().getFullYear() }} UNICAMPO. Todos os direitos reservados.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import appConfig from "@/app.config";

export default {
  props: {
    email: {
      type: String,
      required: true
    }
  },

  page: {
    title: "Sucesso solicitação",
    meta: [{ name: "description", content: appConfig.description }],
  },
  data() {
    return {
      ip: null,
      linkVoltar: '',
    };
  },

  methods: {
    redirectToPortal() {
      const url = "https://unicampo.coop.br";
      window.location.href = url;
    }
  },
};
</script>

<style scoped>
.texto-sucesso {
  height: 75px;
}
.btn-redirect {
  width: 100%;
  border: none;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
  font-weight: 500;
  padding: 10px 20px;
  border-radius: 5px;
  text-align: center;
  display: inline-block;
  text-decoration: none;
  transition: all 0.3s ease;
  box-shadow: 0 4px 10px rgba(13, 110, 253, 0.3);
  background: linear-gradient(135deg, #0D6EFD, #0B5ED7);
}

.btn-redirect:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 14px rgba(13, 110, 253, 0.4);
  background: linear-gradient(135deg, #0B5ED7, #0A58CA);
}

.btn-redirect:focus {
  outline: none;
  box-shadow: 0 0 0 4px rgba(13, 110, 253, 0.4);
}

.bg-avatar {
  background-color: #d5e5fa !important;
}

.color-avatar {
  color: #2c7be5 !important;
}
</style>